// Keeps only digits and one decimal point, with no more decimals than the currency allows.
// `decimals` is the default currency's decimalNumbers (the same value reports pass to toFixed).
export const sanitizeDecimalInput = (value, decimals = 2) => {
    const cleaned = String(value ?? "").replace(/[^0-9.]/g, "");
    const [whole, ...rest] = cleaned.split(".");
    if (rest.length === 0 || decimals <= 0) return whole;
    return `${whole}.${rest.join("").slice(0, decimals)}`;
};
